import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { PipesModule } from '@shared/pipes/pipes.module';
import { RecipeLite } from '@shared/models/recipe/recipe-lite.model';
import { Utils } from '@shared/utils/utils';

@Component({
  selector: 'app-medias-list',
  templateUrl: 'medias-list.component.html',
  styleUrls: ['./medias-list.component.scss'],
  imports: [CommonModule, MatIconModule, PipesModule],
})
export class MediasListComponent {
  @Input() recipeOriginal?: RecipeLite;

  isYoutubeVideo(url: string = ''): boolean {
    return Utils.isYoutubeVideo(url);
  }

  transformForYoutube(url: string = ''): string {
    return Utils.transformUrlForYoutube(url);
  }
}
